import React, { Component } from "react";
import Loading from "../components/Loading";

export default class Logout extends Component {

  constructor(props) {

    super(props);

    localStorage.clear();

    this.state = {}

    window.location.href = "/"

  }

  render() {

    return (
        <Loading/>
    );
  }
}
